<template>
  <Row
    :left-title="symbol"
    :right-title="emptyRightTitle"
    :left-subtitle="description.type"
    :right-subtitle="description.value"
  >
    <template #icon-left>
      <InstrumentAvatar
        :symbol="symbol"
        :instrument-type="type"
        size="medium"
      />
    </template>
  </Row>
</template>

<script setup lang="ts">
import { Row } from '@warrenbrasil/nebraska-web';
import { InstrumentAvatar } from '@/modules/trade/components/InstrumentAvatar';

import { InstrumentType } from '@/modules/trade/types/bff';
import { AssetDetailsDescription } from '@/modules/trade/services/portability';

interface Props {
  symbol: string;
  description: AssetDetailsDescription;
  type: InstrumentType;
}
defineProps<Props>();

// Uses a special character &#x200B; that was no width but has height to fill the right title,
// so it shows the right subtitle at the bottom of the row not at the top
const emptyRightTitle = '​';
</script>

<style lang="less" scoped></style>
